import memoize from "lodash.memoize";

import { createTypesFor } from "utils";

export const prefixes = {
  CHANGE_PAGE: "[pagination] change page ",
  CHANGE_DISPLAYING: "[pagination] change display ",
  SET_TOTAL_ROWS: "[pagination] set total rows ",
  SET_START_PAGE: "[pagination] set start page ",
  SET_END_PAGE: "[pagination] set end page ",
  HAS_NEXT_PAGE: "[pagination] has next page ",
  HAS_PREV_PAGE: "[pagination] has previous page ",
  GO_NEXT_PAGE: "[pagination] go next page ",
  GO_PREV_PAGE: "[pagination] go previous page ",
  GO_FIRST_PAGE: "[pagination] go first page ",
  GO_LAST_PAGE: "[pagination] go last page ",
  RESET_PAGE: "[pagination] reset page "
};

export const typesFor = memoize(domain => createTypesFor(domain, prefixes));
